import ViewStockItems from '@/views/hire-desk/ViewStockItems.vue'
import ViewHireDesk from '@/views/hire-desk/ViewHireDesk.vue'
import ViewPickItems from '@/views/hire-desk/ViewPickItems.vue'
import ViewCollectionItems from '@/views/hire-desk/ViewCollectionItems.vue'
import ViewStockList from '@/views/hire-desk/ViewStockList.vue'
import ViewPickList from '@/views/hire-desk/ViewPickList.vue'
import ViewJourneyList from '@/views/hire-desk/ViewJourneyList.vue'
import ViewCollectionList from '@/views/hire-desk/ViewCollectionList.vue'
import ViewJourneyItems from '@/views/hire-desk/ViewJourneyItems.vue'

export default [
	{
		path: '/hire-desk',
		name: 'hire-desk',
		component: ViewHireDesk,
		meta: {
			group: 'hire-desk',
			permissions: ['view-hire-desk']
		}
	},
	{
		path: '/hire-desk/stock-items',
		name: 'hire-desk-stock-items',
		component: ViewStockList,
		meta: {
			group: 'hire-desk',
			permissions: ['view-hire-desk']
		}
	},
	{
		path: '/hire-desk/stock-item/:id(.*)',
		name: 'hire-desk-stock-item',
		component: ViewStockItems,
		meta: {
			group: 'hire-desk',
			permissions: ['view-hire-desk']
		}
	},
	{
		path: '/hire-desk/pick-items',
		name: 'hire-desk-pick-items',
		component: ViewPickList,
		meta: {
			group: 'hire-desk',
			permissions: ['view-hire-desk']
		}
	},
	{
		path: '/hire-desk/pick-item/:id(.*)',
		name: 'hire-desk-pick-item',
		component: ViewPickItems,
		meta: {
			group: 'hire-desk',
			permissions: ['view-hire-desk']
		}
	},
	{
		path: '/hire-desk/journey-items',
		name: 'hire-desk-journey-items',
		component: ViewJourneyList,
		meta: {
			group: 'hire-desk',
			permissions: ['view-hire-desk']
		}
	},
	{
		path: '/hire-desk/journey-item/:id(.*)',
		name: 'hire-desk-journey-item',
		component: ViewJourneyItems,
		meta: {
			group: 'hire-desk',
			permissions: ['view-hire-desk']
		}
	},
	{
		path: '/hire-desk/collection-items',
		name: 'hire-desk-collection-items',
		component: ViewCollectionList,
		meta: {
			group: 'hire-desk',
			permissions: ['view-hire-desk']
		}
	},
	{
		path: '/hire-desk/collection-item/:id(.*)',
		name: 'hire-desk-collection-item',
		component: ViewCollectionItems,
		meta: {
			group: 'hire-desk',
			permissions: ['view-hire-desk']
		}
	}
]
